import { ProtocolContentData } from "../../protocol";
export default class BunkerBargeOffData extends ProtocolContentData {
    name;
    freeText;
    finishOperation;
    quantity;
    unit;
    constructor(name, finishOperation, quantity, unit, freeText) {
        super();
        this.name = name;
        this.finishOperation = finishOperation;
        this.freeText = freeText;
        this.quantity = quantity;
        this.unit = unit;
    }
}
//# sourceMappingURL=BunkerBargeOffData.js.map